import React from 'react';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';

/* Editable and Read-Only toggling text area */
export const ExpandingTextArea = (props) => {
  const {
    id,
    disabled,
    value,
    label,
    closedLabel,
    fieldName,
    displayError,
    errorMessages,
    handleChange,
    expanded,
    handleBlur,
    maxLength,
    rows,
  } = props;

  if (expanded) {
    return (
      <TextAreaField
        className="util--full-width"
        value={value}
        title={label}
        label={label}
        id={`${fieldName}-${id}`}
        name={fieldName}
        disabled={disabled}
        handleChange={(e, data) => handleChange(data.value)}
        handleBlur={() => handleBlur()}
        displayError={displayError}
        errorMessages={errorMessages}
        maxLength={maxLength}
        rows={rows}
      />
    );
  }
  return (
    <React.Fragment>
      {closedLabel && <strong>{closedLabel}</strong>}
      <p>
        {displayError ? <span className="errorMessages">{errorMessages}</span> : value}
      </p>
    </React.Fragment>
  );
};
